export default function TS_JS_Projects() {
  return (
    <div>
      <h1>TS in JS Projects</h1>
      <p>This is the TS in JS Projects page.</p>
    </div>
  );
}